"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _Tabs = require("./Tabs.style");

var TabLabel = function TabLabel(_ref) {
  var theme = _ref.theme,
      className = _ref.className,
      style = _ref.style,
      _onClick = _ref.onClick,
      text = _ref.text,
      value = _ref.value,
      active = _ref.active,
      disabled = _ref.disabled,
      required = _ref.required,
      index = _ref.index,
      size = _ref.size,
      vertical = _ref.vertical,
      isDarkTheme = _ref.isDarkTheme,
      isMobile = _ref.isMobile;
  var tabLayoutStyles = isDarkTheme ? _Tabs.tabStylesDark : _Tabs.tabStyles;
  return _react.default.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: (0, _classnames.default)(className, tabLayoutStyles(theme, active, disabled, index, size, vertical, isMobile)),
    style: style,
    disabled: disabled,
    onClick: function onClick() {
      return disabled || _onClick(value, index);
    }
  }, text, " ", required && _react.default.createElement("sup", null, "*"));
};

TabLabel.propTypes = {
  text: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  active: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  required: _propTypes.default.bool,
  isMobile: _propTypes.default.bool
};
TabLabel.defaultProps = {
  active: false,
  disabled: false,
  style: {},
  className: '',
  onClick: function onClick() {},
  required: false,
  isMobile: false
};

var _default = (0, _emotionTheming.withTheme)(TabLabel);

exports.default = _default;